import React from 'react';
import { MenuProps } from 'antd';
import { CustomerServiceOutlined, SwapOutlined } from '@ant-design/icons';
import moon from '../DarkThemeSwitch/img/moon.svg';
import sun from '../DarkThemeSwitch/img/sun.svg';
import { AppSystem } from '../../interfaces';
import { useAppSystem, useIsMobile, useProfileFeatureFlags, useProfileIsRight, useUiDarkTheme } from '../../hooks';
import { tB, tI } from '../../translate';

export const useMobileMenuItems = (): MenuProps['items'] => {
    const isMobile = useIsMobile();
    const isDark = useUiDarkTheme();
    const appSystem = useAppSystem();
    const featureFlags = useProfileFeatureFlags();
    const isLord = useProfileIsRight('LORD');

    const menuItems: MenuProps['items'] = [];

    if (isMobile) {
        if (isLord && featureFlags?.newChargingSystem) {
            const appSystemLabel = appSystem === AppSystem.OCS ? 'Billing System' : 'OCS';
            const appSystemKey = appSystem === AppSystem.OCS ? AppSystem.BILLING : AppSystem.OCS;
            menuItems.push({
                key: appSystemKey,
                label: <a href={'#'}>{appSystemLabel}</a>,
                icon: <SwapOutlined />,
            });
        }
        if (appSystem === AppSystem.OCS) {
            menuItems.push({
                key: 'supportPage',
                label: <a href={'/support-page'}>{tI('Support Page')}</a>,
                icon: <CustomerServiceOutlined />,
            });
        }
        menuItems.push({
            key: isDark ? 'lightTheme' : 'darkTheme',
            label: (
                <a href={'#'} className={'darkThemeMenuItem'}>
                    {isDark ? tB('Light Theme') : tB('Dark Theme')}
                </a>
            ),
            icon: <img src={isDark ? sun : moon} alt={'moon'} />,
        });
        menuItems.push({ type: 'divider' });
    } else {
        return [];
    }

    return menuItems;
};
